import { useEffect, useState } from "react";
import { useLeapSdk } from "../../context/sdk";
import { Grid } from "@mantine/core";

export default function NFT() {
  const walletAddress = "0xa48EdE22744A055bfa5EA4be441742299c684efB";
  const contractAddress = [
    "0x1737796c5C090E8BC6CD1FAed5512633f95B457C",
    "0xb541E81E7F6B239E3736cb6FfFA3BA6118BF835a",
  ];
  const [loadingNFTs, setLoadingNFTs] = useState(true);
  const [allCollections, setAllCollections] = useState([]);
  const { loading, leapSdk } = useLeapSdk();

  useEffect(() => {
    async function fetchNfts() {
      const allCollections = await Promise.all(
        contractAddress.map(async (add) => {
          const collection = {
            collectionName: add,
            allTokens: [],
          };

          const contract = leapSdk.getERC721ApiProvider(add, walletAddress);
          const collectionData = await contract.getCollectionData();
          const allTokens = await contract.getAllERC721Tokens();
          collection.collectionName = `${collectionData.name} (${collectionData.symbol})`;
          collection.allTokens = allTokens;
          return collection;
        })
      );
      setAllCollections(allCollections);
      setLoadingNFTs(false);
    }
    if (!loading) {
      fetchNfts();
    }
  }, [loading]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <h1 style={{ paddingTop: "20px" }}>Your NFTS</h1>
      {!loadingNFTs &&
        allCollections.map((collection, index) => (
          <NFTCollection collection={collection} key={index.toString()} />
        ))}
      {loadingNFTs && <Loading />}
    </div>
  );
}

function Loading() {
  return <h2 style={{ margin: "auto" }}>Loading...</h2>;
}

const NFTItem = ({ img, name }) => {
  return (
    <div
      style={{
        display: "flex",
        width: "200px",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          height: "200px",
          width: "200px",
          backgroundColor: "#F7F7F7",
          borderRadius: "20px",
        }}
      >
        <img
          src={img}
          style={{ width: "100%", height: "100%" }}
          alt="item name"
        />
      </div>
      <h4>{name}</h4>
    </div>
  );
};

const NFTCollection = ({ collection }) => {
  return (
    <div style={{ marginTop: "20px" }}>
      <Grid>
        <Grid.Col>
          <h2 style={{ marginTop: "20px" }}>{collection.collectionName}</h2>
        </Grid.Col>
        {collection.allTokens.length === 0 ? (
          <Grid.Col>
            <EmptyCollection />
          </Grid.Col>
        ) : (
          collection.allTokens.map((token, index) => (
            <Grid.Col xs={3} key={index.toString()}>
              {<NFTItem img={token.image} name={token.name} />}
            </Grid.Col>
          ))
        )}
      </Grid>
    </div>
  );
};

const EmptyCollection = () => {
  return (
    <div
      style={{
        display: "flex",
        height: "50px",
        backgroundColor: "#F7F7F7",
        borderRadius: "20px",
        marginTop: "16px",
        width: "fit-content",
        justifyContent: "flex-start",
        padding: "10px 20px",
      }}
    >
      <h4 style={{ margin: "auto", color: "black" }}>
        You don't own any nft in this collection
      </h4>
    </div>
  );
};
